import { Card } from 'components';
import { LinkGuard } from 'components/RoleGuard';
import { AlertDefinition } from 'domain/models/api.models';
import { AppRoutes } from 'domain/routes';
import { useAlertBadge } from 'domain/utils/time.utils';
import { AlertList } from 'pages/common/AlertList';
import { useTranslation } from 'react-i18next';

export const AlertCard = ({ item }: { item: AlertDefinition }) => {
	const { t } = useTranslation(['entities', 'labels']);

	const { status } = useAlertBadge(item);

	return (
		<LinkGuard
			role='ROLE_ADMIN'
			to={AppRoutes.EditAlert.replace(':id', '' + item.id)}>
			<Card className={item.deleted ? 'border-0 opacity-50' : ''}>
				<Card.Header>
					<Card.Badge status={status}></Card.Badge>
					<Card.Titles>
						<Card.Title>{item.name}</Card.Title>
						<Card.Subtitle>{item.scientificName || '-'}</Card.Subtitle>
					</Card.Titles>
					<Card.Info>
						<Card.InfoItemLabel>
							{t('labels:alerts', { count: item?.alertCount ?? 0 })}
						</Card.InfoItemLabel>
						<Card.InfoItemLabel className='text-xs'>
							{t('labels:1_month')}
						</Card.InfoItemLabel>
					</Card.Info>
				</Card.Header>
				<Card.Body>
					<AlertList list={item?.alerts || []} />
				</Card.Body>
			</Card>
		</LinkGuard>
	);
};
